export const LciValidationLabels = {
    firstName: { english: 'First name', spanish: 'Nombre' },
    lastName: { english: 'Last name', spanish: 'Apellido' },
    dateOfBirth: { english: 'Date of birth', spanish: 'Fecha de nacimiento' },
    dateOfDeath: { english: 'Date of death', spanish: 'Fecha de fallecimiento' },
    ssn: { english: 'SSN', spanish: 'SSN' },
    employeeId: { english: 'Employee ID', spanish: 'ID de empleado' },
    sexAssignedAtBirth: { english: 'Sex assigned at birth', spanish: 'Sexo asignado al nacer' },
    phoneNumber: { english: 'Phone number', spanish: 'Número de teléfono' },
    relationshipToEmployee: { english: 'Relationship to employee', spanish: 'Relación con el empleado' },
    name: { english: 'Name', spanish: 'Nombre' },
    phone: { english: 'Phone', spanish: 'Teléfono' },
    email: { english: 'Email', spanish: 'Correo electrónico' },
    notes: { english: 'Notes', spanish: 'Notas' },
    waiverOfPremium: { english: 'Waiver of premium', spanish: 'Exención de la prima' },
    claimant: { english: 'Claimant', spanish: 'Reclamante' },
    state: { english: 'State', spanish: 'Estado' },
    province: { english: 'Province', spanish: 'Provincia' },
    postalCode: { english: 'Postal code', spanish: 'Código postal' },
    addressLine1: { english: 'Address Line 1', spanish: 'Línea de dirección 1' },
    addressLine2: { english: 'Address Line 2', spanish: 'Línea de dirección 2' },
    city: { english: 'City', spanish: 'Ciudad' },
    country: { english: 'Country', spanish: 'País' },
    dateEmployed: { english: 'Date employed', spanish: 'Fecha de empleo' },
    lastWorked: { english: 'Last worked', spanish: 'Último día trabajado' },
    datePremiumLastPaid: { english: 'Date premium last paid', spanish: 'Fecha del último pago de prima' },
    dateOfDisability: { english: 'Date of disability', spanish: 'Fecha de discapacidad' },
    dependentEffectiveDate: { english: 'Dependent effective date', spanish: 'Fecha de vigencia del dependiente' },
    lastBenefitsChangeDate: { english: 'Last benefits change date', spanish: 'Fecha del último cambio de beneficios' },
    reason: { english: 'Reason', spanish: 'Motivo' },
    employeeBasic: { english: 'Employee basic', spanish: 'Básico del empleado' },
    employeeBasicADD: { english: 'Employee basic AD&D', spanish: 'AD&D básico del empleado' },
    employeeOptional: { english: 'Employee optional', spanish: 'Opcional del empleado' },
    employeeOptionalADD: { english: 'Employee optional AD&D', spanish: 'AD&D opcional del empleado' },
    dependentBasic: { english: 'Dependent basic', spanish: 'Dependiente básico' },
    dependentBasicADD: { english: 'Dependent basic AD&D', spanish: 'AD&D básico del dependiente' },
    dependentOptional: { english: 'Dependent optional', spanish: 'Dependiente opcional' },
    dependentOptionalADD: { english: 'Dependent optional AD&D', spanish: 'AD&D opcional del dependiente' },
    terminationDate: { english: 'Termination date', spanish: 'Fecha de terminación' },
    retirementDate: { english: 'Retirement date', spanish: 'Fecha de jubilación' },
    scheduledWorkHours: { english: 'Scheduled work hours', spanish: 'Horas de trabajo programadas' },
    earnings: { english: 'Earnings', spanish: 'Ingresos' },
    workStatus: { english: 'Work status', spanish: 'Estado laboral' },
    insuranceAtRetirement: { english: 'Insurance at retirement', spanish: 'Seguro al jubilarse' },
    event: { english: 'Event', spanish: 'Evento' },
};
